import React from 'react'
import { useTranslation } from 'react-i18next'
import MeasurementFlow from '../measurementFlow'

interface Props {
    _ref: any
    onContinue: (data: any) => void
}

const DirectMeasurementFlowModal: React.FC<Props> = ({ _ref, onContinue }) => {
    const { t } = useTranslation()
    return (
        <dialog ref={_ref} className="modal">
            <div className="modal-box w-11/12 max-w-5xl p-0">
                <MeasurementFlow popup={true} />
            </div>
            <form method="dialog" className="modal-backdrop">
                <button type="button">{t('close')}</button>
            </form>
        </dialog>
    )
}

export default DirectMeasurementFlowModal
